import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const fetchAllRecyclers = async () => {
  try {
    return await API.get(APIEndpoints.GET_RECYCLERS, null, { size: 2000 });
  } catch (error) {
    console.error(error);
  }
};
export const RecyclersAPI = {
  fetchAllRecyclers,
};
